import { isRichTextValueConsideredEmpty } from "@uniformdev/richtext";

import { Accordion } from "@/libraries/design/components/accordion/src/accordion.tsx";
import { RichTextComponent } from "@/libraries/design/utils";

export interface UniformAccordionProps {
    header: string;
    id?: string;
    textBody?: string;
    richText?: string;
    uniformRichText?: unknown;
}
const UniformAccordion = (props: UniformAccordionProps) => {
    const { id, header, textBody, richText } = props;
    return (
        <Accordion
            id={id}
            header={header}
            content={
                richText ? (
                    <RichTextComponent text={richText} />
                ) : !isRichTextValueConsideredEmpty(props.uniformRichText) ? (
                    <RichTextComponent uniformParameter="uniformRichText" />
                ) : (
                    textBody
                )
            }
        />
    );
};

export default UniformAccordion;
